import React from 'react';
import UnifiedLogin from '@components/UnifiedLogin';
import { getHostname } from '@services/utils';

const Login = () => {
  const hostname = getHostname();
  const theme = hostname.includes('dxscontrols') ? 'light' : 'dark';
  
  return (
    <UnifiedLogin theme={theme} />
  );
};

export default Login;